<template>
        <div class="scrollableY cmsInAccWidther" style="z-index: 0">
          <div class=" bottom60 has-text-light settsPad">
            <div class="bottom20">&nbsp;</div>
            <!--  <div class="has-text-left top20 is-size-2">ACCOUNT SETTINGS</div> -->
              <div class="has-background-dark pad10 limitWidth roundedCorners colorLeft">
                <div>You've created:</div>
                <div><b>{{parseInt(bCount).toLocaleString()}}</b> Bundles and <b>{{parseInt(mCount).toLocaleString()}}</b> Miimus</div> 
              </div>

              <div class="limitWidth top30 ">
                  <div id="form1">
                      <form class="form" v-on:submit.prevent="submitForm1" v-if="showForm" name="form1" data-vv-scope="form1">
                         <!--  <div class="field is-size-4  has-text-centered"  >
                              Change Personal Information:
                          </div> -->
                          <div class="field" :class="{formError: errors.first('form1.fName') }">
                              First Name:
                              <input type="text" class="input  " name="fName" data-vv-as="First Name" v-validate="'required'" v-model="form.fName" />
                              <p class="help is-danger" >
                                  {{ errors.first('form1.fName') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('form1.lName') }">
                              Last Name:
                              <input type="text" class="input  " name="lName" data-vv-as="Last Name" v-validate="'required'" v-model="form.lName"/>
                              <p class="help is-danger" >
                                  {{ errors.first('form1.lName') }}
                              </p>
                          </div>
                         <!--  <div class="field">
                              Company:
                              <input type="text" class="input is-coolGreen" name="Company" v-model="form.company"/>
                          </div> -->
                          <!-- <div class="field" :class="{formError: errors.first('form1.phone') }">
                              Phone
                              <input type="text"  class="input  " name="phone" v-validate="'required'" data-vv-as="Phone" v-model="form.phone" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" />
                              <p class="help is-danger" >
                                  {{ errors.first('form1.phone') }}
                              </p>
                          </div>
                           <div class="field" :class="{formError: errors.first('form1.Address') }">
                              Address:
                              <input type="text" class="input  " name="Address" v-validate="'required'" v-model="form.shipAddress1"/>
                              <p class="help is-danger" >
                                  {{ errors.first('form1.Address') }}
                              </p>
                          </div>
                           <div class="field" >
                              <input type="text" class="input  " name="Address2"  v-model="form.shipAddress2"/>
                          </div>
                          <div class="field" :class="{formError: errors.first('form1.City') }">
                              City:
                              <input type="text" class="input  " name="City" v-validate="'required'" v-model="form.shipCity"/>
                              <p class="help is-danger" >
                                  {{ errors.first('form1.City') }}
                              </p>
                          </div>
                           <div class="field" :class="{formError: errors.first('form1.State') }">
                              State:
                              <input type="text" class="input  " name="State" v-validate="'required'" v-model="form.shipState" />
                              <p class="help is-danger" >
                                  {{ errors.first('form1.State') }}
                              </p>
                          </div>
                           <div class="field" :class="{formError: errors.first('form1.Zip') }">
                              Zip:
                              <input type="text" class="input  " name="Zip" v-validate="'required'" v-model="form.shipZip"/>
                              <p class="help is-danger" >
                                  {{ errors.first('form1.Zip') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('form1.Country') }">
                              Country:<br/>
                              <div class="select  width100">
                                  <select  name="Country" class="width100 darkInputCountry"  v-validate="'required'" v-model="form.shipCountry" >
                                      <option disabled value="">Select...</option>
                                      <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                  </select>
                              </div>
                              <p class="help is-danger" >
                                  {{ errors.first('form1.Country') }}
                              </p>
                          </div> -->
                         
      
                          <div class="field">
                              <button id="save1" type="submit" class="button is-coolGreen top10">SAVE</button>
                          </div>
      
                      </form>
                  </div>
  
                  <div v-if="showForm">
                      <hr/>
                  </div>
  
                  <form class="form" v-on:submit.prevent="submitForm2" v-if="showForm" name="form2" data-vv-scope="form2">
                      <div class="field is-size-4"  >
                          Change Password:
                      </div>
                      <div class="field" :class="{formError: errors.first('form2.OldPassword') } ">
                          Old Password:
                          <input class="input  " type="password" name="OldPassword" v-validate="{required: true}" data-vv-as="Old Password" v-model="form2.oldPassword"  data-vv-scope="form2"/>
                          <p class="help is-danger" >
                              {{ errors.first('form2.OldPassword') }}
                          </p>
                          </div>
                      <div class="field" :class="{formError: errors.first('form2.Password') }" >
                          New Password:
                          <input class="input  " type="password" name="Password" data-vv-as="New Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form2.password"/>
                          <p class="help is-danger" >
                              {{ errors.first('form2.Password') }}
                          </p>
                          <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</span>
                      </div>
                      <div class="field" :class="{formError: errors.first('form2.password2') }">
                          Confirm Password:
                          <input class="input  " type="password" name="password2" data-vv-as="Confirm Password" v-validate="{required:true, is: form2.password}" />
                          <p class="help is-danger" >
                              {{ errors.first('form2.password2') }}
                          </p>
                      </div>
  
                      <div class="field">
                          <button id="save2" type="submit" class="button is-coolGreen top10">SAVE</button>
                      </div>
                  </form>
  
                  <div v-if="showForm">
                      <hr/>
                  </div>
  
                  <form class="form" v-on:submit.prevent="submitForm3" v-if="showForm && $root.app.userAttrs['custom:isDisp'] != 'true'" name="form3" data-vv-scope="form3">
                      <div class="field is-size-4"  >
                          Change Email:
                      </div>
                      <div class="has-text-weight-bold">
                          Currently: {{this.$root.app.userAttrs.email}}
                      </div>
                      <div class="top20" >NOTE: You use your email address to log in. You will be sent a confirmation code to the new email address you provide. If you
                          do not have access to the new email address, do not proceed. You will lose access to your services.
                      </div>
                      <div class="field top10" :class="{formError: errors.first('form3.email') }">
                          Email:
                          <input type="text" class="input  " name="email" data-vv-as="Email" v-validate="'required|email'" v-model="form3.email" />
                          <p class="help is-danger" >
                              {{ errors.first('form3.email') }}
                          </p>
                      </div>
                      <div class="field" :class="{formError: errors.first('form3.email2') }">
                          Confirm Email:
                          <input type="text" class="input  " name="email2" data-vv-as="Confirm Email" v-validate="{required:true, is: form3.email}"  />
                          <p class="help is-danger" >
                              {{ errors.first('form3.email2') }}
                          </p>
                      </div>
  
                      <div class="field">
                          <button id="save3" type="submit" class="button is-coolGreen top10">SAVE</button>
                      </div>
                  </form>

                  <div>
                      <hr/>
                  </div>

                  <div class="field is-size-4 top40"  >
                          DELETE ACCOUNT
                  </div>
                  <div>Please click the button to begin the account deletion request.</div>
                  <button class="button is-coolGreen top20" @click="$parent.loadItem('delacc')">DELETE ACCOUNT</button>
  
                  <div v-if="!showForm">
                      <div class="subtitle">
                          <span class="has-text-light">Thank you!</span>
                      </div>
                      <div>
                         <span class="has-text-light"> {{successMessage}}</span>
                      </div>
                      <div class="top20">
                          <button class="button is-coolGreen" @click="$router.push('/')">HOME</button>
                      </div>
  
                  </div>
              </div>
          </div>
          <br> <br> <br> <br>
          <!-- <footerDiv></footerDiv> -->
        </div>
</template>

<script>
import countries from '../static/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
import footerDiv from './Footer.vue'

export default{
  components: {footerDiv},
  data: function () {
    var form = {
      fName: '',
      lName: '',
      /* company: '', */
      phone: '',
      shipAddress1: '',
      shipAddress2: '',
      shipCity: '',
      shipState: '',
      shipZip: '',
      shipCountry: '',
     
    }

    var form2 = {
      oldPassword: '',
      password: ''
    }

    var form3 = {
      email: ''
    }

    return {
      form: form,
      form2: form2,
      form3: form3,
      showForm: true,
      successMessage: '',
      countries: countries,
      inited: false,
      bCount: 0,
      mCount: 0
    }
  },
  /* watch: { // when /accsettings page is refreshed or freshly loaded sesson is checked, must refresh attr values:
    '$root.userAttrs': function (newVal, oldVal) {
      this.form.fName = this.$root.userAttrs.given_name,
      this.form.lName = this.$root.userAttrs.family_name,
      this.form.company = this.$root.userAttrs['custom:company'],
      this.form.city = this.$root.userAttrs['custom:city'],
      this.form.country = this.$root.userAttrs['custom:countryCode']
    }
  }, */
  mounted: function () {
   
      //get account values from DB
       var self = this;
        self.worked = function (data) {
            az.addRemSpinner(false, 'id', 'form1');
            var obj = data.response[0];
            for(var i in obj){
                self.form[i] = obj[i];
            }

            self.mCount = data.assets.m
            self.bCount = data.assets.b
        }
        self.noWorked = function (data, status, headers, config, msg, errorRequest) {
            az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        function init(){
            self.$root.app.apiClient.get('auth/account', {}, self.worked, self.noWorked);
        }

        az.addRemSpinner(true, 'id', 'form1');

        if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
          if(self.inited == false)
            init();
        });
  },

  beforeDestroy: function(){
    AZEventBus.$off('onFederate')
  },

  methods: {
    submitForm1: function () {
      var self = this
      this.$validator.validateAll('form1').then((res) => {
        if (res) {
          updateDB()
        } else {
          this.$root.app.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function updateDB(){
        az.addRemSpinner(true, 'id', 'save1');
        function worked(data) {
            if(data.statusCode == '406'){
                az.addRemSpinner(false, 'id', 'save1');
                az.addRemSpinner(false, 'id', 'form1');
                self.$root.app.showModalOK({message: 'DB Error: There was an error updating your information.'})
                return;
            }
            /* az.addRemSpinner(false, 'id', 'form1');
            var obj = data.response[0];
            for(var i in obj){
                self.form[i] = obj[i];
            } */
            //updateAttrs();
            self.successMessage = 'Your personal information has been successfully updated.'
            self.showForm = false
            az.addRemSpinner(false, 'id', 'form1');  
            az.addRemSpinner(false, 'id', 'save1');
        }
        function noWorked(data, status, headers, config, msg, errorRequest) {
            az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        az.addRemSpinner(true, 'id', 'form1');
        self.$root.app.apiClient.put('auth/account', self.form, worked, noWorked);

      }

      /* function updateAttrs () {
        az.addRemSpinner(false, 'id', 'form1');  
        

        var attributes = [
          {Name: 'given_name', Value: self.form.fName},
          {Name: 'family_name', Value: self.form.lName},
        ]

        self.$root.azCognito.updateAttributes(attributes, updateAttrsCallback)

        function updateAttrsCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save1');
          
          if (result == 'success') {
            self.successMessage = 'Your personal information has been successfully updated.'
            self.showForm = false

            for (var i = 0; i < attributes.length; i++) {
              self.$root.userAttrs[attributes[i].Name] = attributes[i].Value
            }
          } else if (result == 'error') {
            self.$root.showModalOK({message: 'There was an error updating your information.'})
          }
        }
      } */
    },
    submitForm2: function () {
      var self = this
      this.$validator.validateAll('form2').then((res) => {
        if (res) {
          // this.showForm = false;
          changePassword()
        } else {
          this.$root.app.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function changePassword () {
        az.addRemSpinner(true, 'id', 'save2');

        self.$root.app.azCognito.changePassword(self.form2.oldPassword, self.form2.password, changePasswordCallback)

        function changePasswordCallback (result, err) {
          az.addRemSpinner(false, 'id', 'save2');
          if (result == 'error') {
            if (err.code == 'InvalidParameterException' || err.code == 'NotAuthorizedException') {
              self.$root.app.showModalOK({message: 'The old password you provided is incorrect. You may use the Forgot Password procedure after logging out if you have forgotten it.'})
            } else if (err.code == 'LimitExceededException') {
              self.$root.app.showModalOK({message: 'The attempts limit has been reached, please try again later'})
            }
            return
          }
          self.successMessage = 'Your password has been successfully updated.'
          self.showForm = false
          window.scrollTo(0, 0)
        }
      }
    },
    submitForm3: function () {
      var self = this
      this.$validator.validateAll('form3').then((res) => {
        if (res) {
          updateEmail()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors on the form'})
        }
      })

      function updateEmail () {
        az.addRemSpinner(true, 'id', 'save3');

        var attributes = [
          {Name: 'email', Value: self.form3.email}
        ]

        self.$root.app.azCognito.updateEmail(attributes, updateEmailCallback)

        function updateEmailCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save3');
          if (result == 'error') {
            if (obj.code == 'AliasExistsException') {
              self.$root.app.showModalOK({message: 'The email provided is already in use! please provide a different one.'})
            } else {
              self.$root.app.showModalOK({message: 'There was an error updating your information.'})
            }
            return
          }

           //cog success: update local attributes and do db call here
    
            self.successMessage = 'We have sent a confirmation email to ' + self.form3.email + ' with a code. Please log back in with your the new email address and provide the code we sent you when prompted.'
            self.showForm = false
            self.$root.app.isAuth = false

            for (var i = 0; i < attributes.length; i++) {
                self.$root.app.userAttrs[attributes[i].Name] = attributes[i].Value
            }

            function worked(data) {
                if(data.statusCode == '406'){
                    //TODO: consider sending admin notification saying congito email was not synced to DB
                }
            }
            function noWorked(data, status, headers, config, msg, errorRequest) {
                    //TODO: consider sending admin notification saying congito email was not synced to DB
            }
            self.$root.app.apiClient.put('auth/account', {email: self.form3.email}, worked, noWorked);
        }
      }
    }
  }
}
</script>

<style scoped>
  input{
    background-color: #333;
    border: none;
    border-bottom: 1px solid #f1c232;
    color: white
  }
</style>

